module.exports = __webpack_public_path__ + "img/4.d6a16f40.png";